export default "__VITE_ASSET__BQXjM88X__"